import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { store } from "@stores";
import { Emitter } from "@utils/events";
import { Constants } from "@app/constants";

@Module({
  dynamic: true,
  store: store,
  name: "products",
  namespaced: true,
})
export class ProductsStoreModule extends VuexModule {
  public comparisonProducts: Products.TableData[] = [];

  @Action public async addProductToComparison(product: Products.TableData): Promise<void> {
    this.context.commit("assignProductToComparison", product);
  }

  @Action public async removeProductFromComparison(product: Products.TableData): Promise<void> {
    this.context.commit("cutProductFromComparison", product);
  }

  @Mutation
  protected assignProductToComparison(product: Products.TableData): void {
    if (this.comparisonProducts.length >= Constants.comparisonListMaxSize) return;

    if (!this.comparisonProducts.find((p) => p.id === product.id)) {
      this.comparisonProducts.push(product);
      Emitter.emit("ci::comparison-cart::added");
    }
  }

  @Mutation
  protected cutProductFromComparison(product: Indexable): void {
    this.comparisonProducts = this.comparisonProducts.filter((p) => p.id !== product.id);
  }
}
